import React from 'react';
import i18next from 'i18next';
import { func, string, bool, number, arrayOf, shape } from 'prop-types';
import cn from 'classnames';
import { useDetectClickOutside } from 'react-detect-click-outside';

import InputLabel from '~components/InputLabel';
import { addressPropTypes } from '~propTypes/address';

import Results from './components/Results';
import styles from './styles.module.scss';

function StoreSearchBar({
  value,
  results,
  className,
  placeholderClassName,
  iconClassName,
  focused,
  onBlur,
  onChange,
  onClean,
  onResultSelect,
  onFirstClick,
  onFocus,
  onResultsMouseOver,
  onResultsMouseOut,
  maxResults,
  loadingResults,
  loadingResultData,
  loadingCurrentLocation,
  showResults,
  placeholder,
  simple,
  lastAddresses,
  selectedAddress,
  onAddressSelect,
  onlySearch = false
}) {
  function handleCleanButtonClick() {
    onClean(true);
  }
  const StoreSearchBarRef = useDetectClickOutside({ onTriggered: onBlur });
  const placeholderText = !loadingCurrentLocation && (placeholder || i18next.t('StoreSearchBar:placeholder'));

  return (
    <div
      className={cn(`column center middle full-width m-bottom-4 ${styles.storeSearchBar}`, className, {
        [styles.styled]: !simple,
        [styles.dirty]: value,
        [styles.focused]: focused,
        [styles.loading]: loadingCurrentLocation || loadingResultData
      })}
      ref={StoreSearchBarRef}>
      <InputLabel
        styledPlaceholder={!simple}
        className={cn('full-width text-highlighted', styles.input)}
        iconClassName={cn(styles.icon, iconClassName)}
        placeholderClassName={cn(styles.placeholder, placeholderClassName)}
        type="text"
        inputType="text"
        id="search"
        autoComplete="off"
        name="searchAddress"
        icon="icon-location2"
        value={value}
        onChange={onChange}
        onClick={onFirstClick}
        onTouchEnd={onFirstClick}
        onFocus={onFocus}
        readOnly={loadingCurrentLocation || loadingResultData}
        placeholder={
          loadingCurrentLocation || loadingResultData
            ? i18next.t('StoreSearchBar:gettingCurrentLocation')
            : placeholderText
        }
        actions={
          <button
            type="button"
            onClick={handleCleanButtonClick}
            className={cn('text-highlighted', styles.clearButton, {
              [styles.active]: value
            })}>
            <i className={`icon-close ${styles.cleanButton}`} />
          </button>
        }
      />
      <Results
        loading={loadingResults}
        results={results}
        maxResults={maxResults}
        onResultSelect={onResultSelect}
        isOpen={showResults}
        onMouseOver={onResultsMouseOver}
        onMouseOut={onResultsMouseOut}
        lastAddresses={lastAddresses}
        selectedAddress={selectedAddress}
        onAddressSelect={onAddressSelect}
        onlySearch={onlySearch}
      />
    </div>
  );
}

StoreSearchBar.propTypes = {
  showResults: bool.isRequired,
  onAddressSelect: func.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onClean: func.isRequired,
  onFirstClick: func.isRequired,
  onFocus: func.isRequired,
  onResultSelect: func.isRequired,
  onResultsMouseOut: func.isRequired,
  onResultsMouseOver: func.isRequired,
  className: string,
  focused: bool,
  iconClassName: string,
  lastAddresses: arrayOf(addressPropTypes),
  loadingCurrentLocation: bool,
  loadingResultData: bool,
  loadingResults: bool,
  maxResults: number,
  onlySearch: bool,
  placeholder: string,
  placeholderClassName: string,
  results: arrayOf(
    shape({
      placeId: string
    })
  ),
  selectedAddress: addressPropTypes,
  simple: bool,
  value: string
};

export default StoreSearchBar;
